import { RouteConfig } from 'vue-router';
import { PermissionsGroupName } from '@/constants/permissions';

export const inventoryLocationsRoutes: RouteConfig[] = [
  {
    path: '/inventory-locations',
    name: 'InventoryLocations',
    component: () => import('@/views/inventory-locations/InventoryLocationsView.vue'),
    meta: {
      pageTitle: 'Inventory Locations',
      permission: PermissionsGroupName.INVENTORY_LOCATIONS,
    },
  },
];
